import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../../shared/auth/auth.service';
import {doSwalError} from '../../../services/swal.services';

import { UsersService } from '../../../user/services/users.services';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})

export class LoginPageComponent {

  @ViewChild('f', {static: false}) loginForm: NgForm;

  constructor(
    private authService: AuthService,
    private translate: TranslateService
  ) { }

  // On submit button click
  onSubmit(f: NgForm) {
    if (true == f.valid) {
      this.authService.signinUser(f.value.inputPseudo, f.value.inputPass);
    }

    this.loginForm.reset();
  }
}
